(function ($) {
	$(document).ready(function () {
		profetEmailSignupFooter = {
			variables: {
				wrapperElement: $('.email-signup-footer-wrapper'),
				formElement: $('#email-signup-footer'),
				messageContainerElement: $('.email-signup-footer-wrapper').find('.message-container'),
				showFullFormButton: $('.email-signup-footer-wrapper').find('.show-full-form'),
				step2Fields: $('.email-signup-footer-wrapper').find('.step-2-fields'),
				timeBeforeAppear: 15000,
				fields: [$('#email-signup-footer').find('input[name="email"]'), $('#email-signup-footer').find('select[name="user_group"]')],
			},
			init: function () {
				profetEmailSignupFooter.handleClicks();
				profetEmailSignupFooter.handleInputChange();
				profetEmailSignupFooter.handleSubmit();
			},
			handleClicks: function () {
				profetEmailSignupFooter.variables.showFullFormButton.on('click', function (event) {
					event.preventDefault();
					profetEmailSignupFooter.variables.showFullFormButton.hide();
					//profetEmailSignupFooter.variables.step2Fields.addClass('visible');
					profetEmailSignupFooter.variables.step2Fields.slideDown(500);
				});
			},
			handleInputChange: function () {
				for (var i in profetEmailSignupFooter.variables.fields) {
					var field = profetEmailSignupFooter.variables.fields[i];
					field.on('change', function () {
						profetEmailSignupFooter.variables.messageContainerElement.html('');
					});
					field.on('keydown', function () {
						profetEmailSignupFooter.variables.messageContainerElement.html('');
					});
				}
				$('select[name="user_group"]').on('change', function () {
					if ($(this).val() == 'Annat') {
						profetEmailSignupFooter.variables.formElement.find('.target-audience-other-wrapper').show();
					} else {
						profetEmailSignupFooter.variables.formElement.find('.target-audience-other-wrapper').hide();
						profetEmailSignupFooter.variables.formElement.find('input[name="user_group_other"]').val('');
					}
				});
			},
			validateFields: function () {
				var emailValue = profetEmailSignupFooter.variables.formElement.find('input[name="email"]').val();
				if (!profetEmailSignupFooter.emailCheck(emailValue)) {
					profetEmailSignupFooter.variables.messageContainerElement.html('Dubbelkolla att din mejladress är korrekt ifylld.');
					return false;
				}

				for (var i in profetEmailSignupFooter.variables.fields) {
					var field = profetEmailSignupFooter.variables.fields[i];
					if (field.val() === '' || !field.val() || !profetEmailSignupFooter.variables.formElement.find('#gdpr').is(':checked')) {
						profetEmailSignupFooter.variables.messageContainerElement.html('Du måste fylla i alla fält och godkänna personuppgiftspolicyn.');
						return false;
					}
				}
				return true;
			},
			emailCheck: function (str) {
				var ret = true;
				var at = '@';
				var dot = '.';
				var lat = str.indexOf(at);
				var lstr = str.length;
				var ldot = str.indexOf(dot);
				if (str.indexOf(at) == -1) {
					ret = false;
				}
				if (str.indexOf(at) == -1 || str.indexOf(at) == 0 || str.indexOf(at) == lstr) {
					ret = false;
				}
				if (str.indexOf(dot) == -1 || str.indexOf(dot) == 0 || str.indexOf(dot) == lstr) {
					ret = false;
				}
				if (str.indexOf(at, lat + 1) != -1) {
					ret = false;
				}
				if (str.substring(lat - 1, lat) == dot || str.substring(lat + 1, lat + 2) == dot) {
					ret = false;
				}
				if (str.indexOf(dot, lat + 2) == -1) {
					ret = false;
				}
				if (str.indexOf(' ') != -1) {
					ret = false;
				}
				return ret;
			},
			handleSubmit: function () {
				profetEmailSignupFooter.variables.formElement.on('submit', function (event) {
					event.preventDefault();
					profetEmailSignupFooter.variables.formElement.find('button[type="submit"]').attr('disabled', true);

					profetEmailSignupFooter.variables.messageContainerElement.html('');

					if (!profetEmailSignupFooter.validateFields()) {
						profetEmailSignupFooter.variables.formElement.find('button[type="submit"]').attr('disabled', false);
						return;
					}

					/*
                    Instead of doing the AJAX call below, we simply open a new window for the user which requests the Paloma API endpoint.
                    We do this because sometimes Paloma needs an extra Recaptcha verification that is done on their website.
                    */

					/* Build the query string from the URL */
					var query = $.param({
						gora: 'pren',
						distlistkey: '182355',
						email: profetEmailSignupFooter.variables.formElement.find('input[name="email"]').val(),
						namn: profetEmailSignupFooter.variables.formElement.find('input[name="name"]').val(),
						userfield_malgrupp: profetEmailSignupFooter.variables.formElement.find('select[name="user_group"]').val(),
					});
					var url = 'https://newsletter.paloma.se//register/?' + query;
					window.open(url);

					/* Hide the button and display a success message */
					window.setTimeout(function () {
						profetEmailSignupFooter.variables.messageContainerElement.html('Tack för din anmälan!');
						profetEmailSignupFooter.variables.formElement.find('button').hide();
					}, 1000);

					/* Send second Ajax request to the API for email software Paloma to add the contact there too */
					/*
					$.ajax({
						method: 'GET',
						url: 'https://newsletter.paloma.se//register/',
						data: {
							gora: 'pren',
							distlistkey: '182355',
							email: profetEmailSignupFooter.variables.formElement.find('input[name="email"]').val(),
							namn: profetEmailSignupFooter.variables.formElement.find('input[name="name"]').val(),
							userfield_malgrupp: profetEmailSignupFooter.variables.formElement.find('select[name="user_group"]').val(),
						},
						success: function (data) {
							console.log('Success');
							console.log(data);
							profetEmailSignupFooter.variables.messageContainerElement.html('Tack för din anmälan!');
							profetEmailSignupFooter.variables.formElement.find('button').hide();
						},
						error: function (error) {
							console.log('Error');
							console.log(error);
							profetEmailSignupFooter.variables.messageContainerElement.html('Något gick fel. Försök igen lite senare.');
							profetEmailSignupFooter.variables.formElement.find('button[type="submit"]').attr('disabled', false);
						},
                    });
                    */

					/* Track form submission in Google Analytics */
					__gaTracker('send', 'event', {
						eventCategory: 'Email signup',
						eventAction: 'click',
						eventLabel: 'Email signup',
						transport: 'beacon',
					});

					return false;
				});
			},
		};
		profetEmailSignupFooter.init();
	});
})(jQuery);
